import { Visibility, VisibilityOff } from '@mui/icons-material'
import { IconButton, InputAdornment } from '@mui/material'
import React from 'react'

const PasswordVisibility = ({ showPassword, onToggle }) => {
    return (
        <InputAdornment position="end" className='mr-1'>
        <IconButton onClick={onToggle} edge="end">
          {showPassword ? <Visibility />:<VisibilityOff />}
        </IconButton>
      </InputAdornment>
    )
}

export default PasswordVisibility